import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import PageTransition from '../components/PageTransition';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      await authService.login({ email, password });
      navigate('/');
      window.location.reload();
    } catch (error) {
      const msg =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      setMessage(msg);
    }
  };

  return (
    <PageTransition>
      <div className="max-w-md mx-auto mt-10 bg-white p-8 rounded-lg shadow-lg border-t-4 border-brand-gold">
        <h1 className="text-3xl font-bold text-center text-brand-green-dark mb-6">
          Welcome Back
        </h1>

        {message && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 text-center">
            {message}
          </div>
        )}

        <form onSubmit={submitHandler} className="space-y-6">
          
          {/* EMAIL FIELD */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              // Ensure this input has the correct styling to be visible and functional
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all duration-200"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* PASSWORD FIELD */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all duration-200"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-brand-green hover:bg-brand-green-dark text-white font-bold py-2 px-4 rounded-md transition-colors duration-200 shadow-md"
          >
            Sign In
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-600">
          New to CarbonSasa?{' '}
          <Link
            to="/register"
            className="text-brand-gold font-bold hover:text-brand-gold-light hover:underline"
          >
            Create an Account
          </Link>
        </div>
      </div>
    </PageTransition>
  );
};

export default LoginPage;